import React, { useCallback, useLayoutEffect, useRef } from 'react';

import { UNKNOWN } from 'pages/item/v2/components/ProtectedData';
import { HistoryOfChangesItem } from 'pages/item/v2/types/history-of-changes';
import isEmpty from 'utils/is-empty';

import ScorePane, { ScorePaneRef } from '../ScorePane';
import TrendTooltip from '../TrendTooltip';

interface Props {
    ssvc: {
        options: Record<string, string>[];
    };
}

const Ssvc: React.FC<Props> = ({ ssvc }) => {
    const scorePaneRef = useRef<ScorePaneRef>(null);
    useLayoutEffect(() => scorePaneRef.current?.setIsOpen(window.innerWidth >= 960), []);

    const getChart = useCallback((data: HistoryOfChangesItem[]) => {
        if (data.every(({ changes }) => 'epss' in changes === false)) return null;
        return data.reduce((output, { version, published, changes }) => {
            const score = changes.epss
                ? Math.max(...changes.epss.map(({ epss }) => epss), 0)
                : output.at(-1)?.score ?? 0;
            output.push({ version, score, published });
            return output;
        }, [] as { score: number; version: number; published: Date }[]);
    }, []);

    if (isEmpty(ssvc?.options)) {
        return null;
    }
    console.log({
        ssvc,
        v: ssvc.options.reduce(
            (acc, option) => ({
                ...acc,
                ...Object.entries(option).reduce((x, [key, value]) => ({ ...x, [key]: value }), {})
            }),
            {}
        )
    });
    return (
        <TrendTooltip getChart={getChart} title="SSVC score statistics">
            <ScorePane
                ref={scorePaneRef}
                name="SSVC"
                score={UNKNOWN}
                severity={UNKNOWN}
                indicator={false}
                vectorItems={ssvc.options.reduce(
                    (accA, option) => ({
                        ...accA,
                        ...Object.entries(option).reduce((accB, [key, value]) => ({ ...accB, [key]: value }), {})
                    }),
                    {}
                )}
            />
        </TrendTooltip>
    );
};

export default Ssvc;
